import { AITrainingMaterialFragment } from 'types/graphql'

import { EllipsisButton } from 'src/components/EllipsisButton'
import { useRetryAITrainingMaterialMutation } from 'src/fetch/aiTrainingMaterials'
import { ActionItem } from 'src/govwell-ui/types'
import useDisclosure from 'src/hooks/use-disclosure'
import { RefetchFnType } from 'src/types'

import DeleteAITrainingMaterialModal from './DeleteAITrainingMaterialModal'

type Props = {
  material: AITrainingMaterialFragment
  refetch: RefetchFnType
}

const AITrainingMaterialsTableButtons = ({ material, refetch }: Props) => {
  const deleteModal = useDisclosure()
  const { mutateAsync: retryMutation, isPending: isRetrying } = useRetryAITrainingMaterialMutation()

  const handleRetry = async () => {
    await retryMutation({ id: material.id })
    await refetch()
  }

  const items: ActionItem[] = [
    ...(material.processingStatus === 'Failed'
      ? [
          {
            label: isRetrying ? 'Retrying...' : 'Retry',
            icon: 'FaArrowsRotate' as const,
            onClick: handleRetry,
            key: 'retry',
            disabled: isRetrying,
          },
        ]
      : []),
    {
      label: 'Delete',
      icon: 'FaTrash',
      onClick: deleteModal.open,
      key: 'delete',
      isDestructive: true,
    },
  ]
  return (
    <>
      <EllipsisButton items={items} />
      {deleteModal.isOpen && (
        <DeleteAITrainingMaterialModal
          modalState={deleteModal}
          id={material.id}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default AITrainingMaterialsTableButtons
